// CUSTOM ICON COMPONENT
import duotone from '@/icons/duotone';

export const navigations = [
  {
    name: 'Dashboard',
    icon: duotone.Dashboard,
    path: '/dashboard'
  },
  {
    name: 'Matches',
    icon: duotone.Calender,
    path: '/matches'
  },
  {
    name: 'Players',
    icon: duotone.UserList,
    path: '/players'
  },
  {
    name: 'Media Library',
    icon: duotone.Folder,
    path: '/media'
  },
  {
    name: 'Content',
    icon: duotone.Edit,
    path: '/content'
  },
  {
    name: 'Teams',
    icon: duotone.LayerGroup,
    path: '/teams',
    requiresClubAdmin: true,
    position: 'bottom'
  },
  {
    name: 'Content Templates',
    icon: duotone.DataTable,
    path: '/content-templates',
    requiresClubAdmin: true,
    position: 'bottom'
  },
  {
    name: 'Social Connections',
    icon: duotone.Send,
    path: '/social-connections',
    position: 'bottom'
  },
  {
    name: 'Club Settings',
    icon: duotone.Settings,
    path: '/club-settings',
    requiresClubAdmin: true,
    position: 'bottom'
  }
];